import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isTrustedAuthUrl } from "../../utils/security/sanitizeUrl";

const MondayAuthPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authUrl = location.state?.authUrl;

  useEffect(() => {
    if (isTrustedAuthUrl(authUrl)) {
      window.location.href = authUrl;
    } else {
      navigate("/", { replace: true });
    }
  }, [authUrl, navigate]);

  return <section className="w-full h-screen"></section>;
};

export default MondayAuthPage;
